import { isValidNumber } from '@edicom/common/number/isValidNumber';

/**
 * Objeto que almacena los metodos de formateo que se van generando por locale, bajo demanda
 */
const cache = {
  // @example
  // `en-US`: {
  //   'number': value => _format(value),
  //   'unit_liter': value => _format(value),
  // },
};

/**
 * unidades de tamaño de ficheros.
 * Nota que existen todas estas:
 * bit, byte, kilobit, kilobyte, megabit, megabyte, gigabit, gigabyte, terabit, terabyte, petabyte
 */
const units = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte'];

/**
 * si 1024 (defecto true) o 1000
 */
const binary = true;

/**
 * Devuelve el tamaño de un fichero humanizado
 *
 * @param {Object} state
 * @param {number} value el tamaño de un fichero en bytes
 * @returns {string}
 */
export function fileSize(state, value) {
  if (!isValidNumber(value)) {
    return '';
  }

  try {
    cache[state.id] = cache[state.id] || {};

    /**
     * Calculamos la unidad (con el quotient)
     * para 1 -> byte
     * para 1000 -> kilobyte
     * ...
     */
    let size = Math.abs(value);
    let quotient = 0;

    if (size) {
      if (binary) {
        quotient = Math.floor(Math.log2(size) / 10);
        quotient = quotient < units.length ? quotient : units.length - 1;
        size /= 1024 ** quotient; // Recalculamos el tamaño en función de la unidad seleccionada
      } else {
        quotient = Math.floor(Math.log10(size) / 3);
        quotient = quotient < units.length ? quotient : units.length - 1;
        size /= 1000 ** quotient; // Recalculamos el tamaño en función de la unidad seleccionada
      }
    }

    /**
     * Recuperamos la función de formateo para la unidad seleccionada
     */
    const unit = units[quotient];
    const formatter = getFormatterFileSize(state, unit);

    /**
     * Formateamos
     */
    return formatter(size);
  } catch (e) {
    console.error(e);
  }

  return '';
}

function getFormatterFileSize(state, unit) {
  const key = `fileSize_${unit}`;

  if (!cache[state.id][key]) {
    const options = {
      style: 'unit',
      unit,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      notation: 'compact',
      // compactDisplay: "short|long", default: "short"
    };
    cache[state.id][key] = new Intl.NumberFormat(state.id, options).format;
  }

  return cache[state.id][key];
}
